import {
  Avatar,
  Button,
  Col,
  Collapse,
  Divider,
  Drawer,
  Form,
  Icon,
  Row,
  Tabs,
  Typography,
  Upload,
  notification,
} from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { RcFile } from 'antd/lib/upload';
import _, { get, isArray } from 'lodash';
import moment from 'moment';
import { TypeUserPermission } from 'o2o_layout/lib/common/model';
import { Methods } from 'o2o_layout/lib/common/rest';
import React from 'react';
import { Link } from 'react-router-dom';
import CommonTypeProps from '../../../common/CommonTypeProps';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { getCurrentURL, getPrimaryColor } from '../../../common/helper';
import { CommonResponse } from '../../../redux/model';
import { TypeEDMSendInBlue } from '../../../redux/reducer/edmSendInBlueReducer';
import { CommonNotificationSaveError, CommonNotificationUpdateSuccessfully } from '../../../shares/CommonNotification';
import { TagPrimaryColor } from '../../../shares/TagPrimaryColor';
import { CommonDAL } from '../../../shares/dal/CommonDAL';
import { typeUpdateOrg } from '../../orgs/OrgsAction';
import { typeUpdateAcount } from '../ConsoleUsersAction';
import { PermissionGroups } from '../permisions/model/permissions';
import { FormUpdateUserInfo } from '../profile/FormUpdateUserInfo';
import { UserTokenDAL } from './dal/UserTokenDAL';
import { UserActivities } from './model/usertoken';
import DashboardPageLayoutV2 from '../../../layout/dashboard/DashboardPageLayoutV2';
import { IconEdit, IconMail, IconPhone, IconPosition } from '@shares/DMPIcon';

interface Props extends CommonTypeProps, FormComponentProps {
  updateAccount: typeUpdateAcount;
  updateOrgByAdminClient: typeUpdateOrg;
  changePwd: any;
  edmSendInBlue: TypeEDMSendInBlue;
  updateEDMSendInBlue: any;
  getEDMSendInBlue: any;
  getMe: any;
  searchPermissionGroup: any;
  permissionGroups: PermissionGroups;
}

export class UserInfoForm extends React.Component<Props, any> {
  formRef: any;
  formRefInfo: any;
  formRefEDM: any;

  state = {
    confirmDirty: false,
    visibleModalUpdateOrg: false,
    visibleInfo: false,
    imageUrl: null as any,
    fileUpload: null as RcFile | null,
    loadingUploadAv: false,
    activities: new UserActivities(),
  };
  timer: any;

  componentDidMount = () => {
    this.getActivity();
    this.props.searchPermissionGroup('');
    this.props.updateMetaTitle({ title: BIGDATA_CONSTANT.trackTitle.Home });
    this.timer = setTimeout(() => {
      this.props.updateMeta({
        name: BIGDATA_CONSTANT.trackTitle.Home,
        title: BIGDATA_CONSTANT.trackTitle.Home,
        app: 'ACCOUNT',
        url: getCurrentURL(this.props.location),
      });
      clearTimeout(this.timer);
    }, 5000);
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  checkCurrentUserIsUser = (): boolean => {
    if (this.props.user) {
      if (this.props.user.orgCtx) {
        let roles = this.props.user.orgCtx.roles;
        let isSP = _.find(roles, (e) => {
          return e == 'USER';
        });

        if (isSP) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  };

  checkCurrentUserIsSuperAdmin = (): boolean => {
    if (this.props.user) {
      if (this.props.user.orgCtx) {
        let roles = this.props.user.orgCtx.roles;
        let isSP = _.find(roles, (e) => {
          return e == 'SUPER_ADMIN';
        });

        if (isSP) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  };

  submitUpdateOrg = (e: any) => {
    const form = this.formRef.props.form;

    form.validateFields((err: any, values: any) => {
      if (err) {
        return;
      }

      this.props.setGlobalLoading(true);
      let isSAdmin = this.checkCurrentUserIsSuperAdmin();

      values.id = this.props.user.orgCtx ? this.props.user.orgCtx.id : null;

      this.props
        .updateOrgByAdminClient(values, isSAdmin)
        .then(() => {
          if (this.props.commonResponse.success) {
            this.props.setGlobalLoading(false);
            this.setState({ visibleModalUpdateOrg: false });
            notification.success({
              message: BIGDATA_CONSTANT.message.default.title.success,
              description: `Organization ${
                this.props.user.orgCtx ? this.props.user.orgCtx.organization.name : ''
              } updated successfully`,
              icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
            });
            setTimeout(() => {
              window.location.reload();
            }, 200);
          } else {
            this.props.setGlobalLoading(false);
            notification.error({
              message: BIGDATA_CONSTANT.message.default.title.error,
              description: this.props.commonResponse.message,
            });
            this.setState({ visibleModalUpdateOrg: false });
          }
        })
        .catch((e: any) => {
          this.props.setGlobalLoading(false);
          notification.error({
            message: BIGDATA_CONSTANT.message.default.title.error,
            description: _.get(e.data, 'message', 'Something went wrong'),
          });
          this.setState({ visibleModalUpdateOrg: false });
        });
    });
  };

  submitUpdateInfo = (e: any) => {
    e.preventDefault();
    this.formRefInfo.props.form.validateFieldsAndScroll((err: any, values: any) => {
      if (!err) {
        let user: any = Object.assign(values, {
          email: values.id,
          status: 'active',
        });

        let promise: any = this.props.updateAccount(user, false, true);
        this.props.setGlobalLoading(true);
        promise
          .then(() => {
            if (this.props.commonResponse.success) {
              notification.success({
                message: BIGDATA_CONSTANT.message.default.title.success,
                description: `User ${this.props.user.id} updated successfully`,
                icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
              });
              this.setState({
                visibleInfo: false,
              });

              setTimeout(() => {
                this.props.getMe().then(() => {
                  this.props.setGlobalLoading(false);
                });
              }, 1000);
            } else {
              this.props.setGlobalLoading(false);
              notification.error({
                message: 'Error',
                description: this.props.commonResponse.message,
              });
            }
          })
          .catch((error: any) => {
            this.props.setGlobalLoading(false);
            notification.error({
              message: 'Error',
              description: _.get(error, 'message', 'Something was wrong.'),
            });
          });
      }
    });
  };

  handleChangeAvatar = (info: RcFile) => {
    if (info.size / 1024 / 1024 > 2) {
      notification.warning({
        message: 'Warning',
        description: 'Please upload only image/png, image/jpeg, or image/jpg files less than 2MB.',
      });
      return false;
    }
    this.setState({
      imageUrl: URL.createObjectURL(info),
      fileUpload: info,
    });
    return false;
  };

  handleUploadAvatar = async () => {
    const result = this.props.commonActionFromDALV2(UserTokenDAL.uploadAvatar, this.state.fileUpload);
    this.setState({
      loadingUploadAv: true,
    });
    try {
      const res: CommonResponse = await result;
      if (res.success) {
        setTimeout(() => {
          this.props.getMe();
        }, 300);
        setTimeout(() => {
          this.setState({
            imageUrl: null,
            fileUpload: null,
          });
        }, 400);
        CommonNotificationUpdateSuccessfully();
      } else {
        CommonNotificationSaveError(res.message);
      }
      this.setState({
        loadingUploadAv: false,
      });
    } catch (error) {
      this.setState({
        loadingUploadAv: false,
      });
      CommonNotificationSaveError(get(error, 'message'));
    }
  };

  getActivity = async () => {
    const result = this.props.commonActionFromDALV2(
      CommonDAL.buildURL,
      BIGDATA_CONSTANT.url.account + 'api/accounts/users/current/last-activity',
      {},
      Methods.GET
    );
    try {
      const res: UserActivities = await result;
      if (res.success) {
        this.setState({
          activities: res,
        });
      } else {
        this.setState({
          activities: new UserActivities(),
        });
      }
    } catch (error) {
      this.setState({
        activities: new UserActivities(),
      });
    }
  };

  renderDraweInfo = () => {
    return (
      <Drawer
        title='Update personal info'
        visible={this.state.visibleInfo}
        onClose={() =>
          this.setState({
            visibleInfo: false,
          })
        }
        width={'400px'}
      >
        <FormUpdateUserInfo
          loading={this.props.ui.isLoading}
          locale={this.props.locale}
          orgCtx={this.props.user.orgCtx}
          wrappedComponentRef={(propsRef: any) => (this.formRefInfo = propsRef)}
          submit={this.submitUpdateInfo}
          user={this.props.user}
        />
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }}
        >
          <Button
            style={{
              marginRight: 8,
            }}
            onClick={() =>
              this.setState({
                visibleInfo: false,
              })
            }
          >
            Cancel
          </Button>
          <Button onClick={this.submitUpdateInfo} type='primary'>
            Save and Close
          </Button>
        </div>
      </Drawer>
    );
  };

  renderContentLayout = (version?: string) => {
    let { name = '', avatar } = this.props.user;
    let initials: any = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();

    let { permission = { ctxGroupPermissions: undefined } as TypeUserPermission } = this.props.authen;
    const { activities } = this.state;
    return (
      <>
        {version === 'v2' && (
          <Tabs
            defaultActiveKey='my-profile'
            onChange={(key: string) => {
              if (key === 'my-profile') this.props.history.push({ pathname: '/my-account-info' });
              if (key === 'security') this.props.history.push({ pathname: '/security/2fa-security' });
              if (key === 'activity') this.props.history.push({ pathname: '/activity/invitation' });
            }}
          >
            <Tabs.TabPane tab='My Profile' key='my-profile' />
            <Tabs.TabPane tab='Security' key='security' />
            <Tabs.TabPane tab='Activity' key='activity' />
          </Tabs>
        )}

        <Row
          type='flex'
          gutter={[35, 0]}
          style={{
            ...(version === 'v2' && {
              paddingLeft: 15,
              paddingTop: 15,
            }),
          }}
        >
          <Col>
            <div
              style={{
                display: 'inline-flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 10,
                marginTop: 8,
              }}
            >
              <Avatar
                src={this.state.imageUrl || avatar}
                style={{ background: getPrimaryColor(this.props.uiSetting) }}
                size={100}
                shape={'circle'}
              >
                {initials}
              </Avatar>
              {this.state.imageUrl ? (
                <div>
                  <Button
                    loading={this.state.loadingUploadAv}
                    onClick={this.handleUploadAvatar}
                    type='link'
                    size='small'
                  >
                    Save Change
                  </Button>
                  <Divider type='vertical' />
                  <Button
                    onClick={() => this.setState({ imageUrl: null })}
                    type='link'
                    size='small'
                    icon='delete'
                  ></Button>
                </div>
              ) : (
                <Upload
                  fileList={[]}
                  accept={'image/png, image/jpeg, image/jpg'}
                  beforeUpload={(file: RcFile, FileList: RcFile[]) => this.handleChangeAvatar(file)}
                  multiple={false}
                >
                  <Button
                    type='link'
                    size='small'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon
                      component={() => (
                        <IconEdit
                          style={{
                            width: 16,
                            height: 16,
                          }}
                        />
                      )}
                    />
                    Change
                  </Button>
                </Upload>
              )}
            </div>
          </Col>
          <Col xs={16} lg={16}>
            <Row gutter={[20, 20]}>
              <Col xs={24}>
                <Typography.Title level={3}>
                  Welcome, {name}!
                  <Button
                    style={{
                      width: 'fit-content',
                      height: 'fit-content',
                      padding: 0,
                      margin: 0,
                    }}
                    onClick={() => {
                      this.setState({
                        visibleInfo: true,
                      });
                    }}
                    type='link'
                  >
                    <Icon className='ml10' component={IconEdit} />
                  </Button>
                </Typography.Title>
                <Typography.Text>
                  Has been added to {get(this.props.user, 'orgCtx.organization.name', null)} since{' '}
                  {moment(this.props.user.createdAt).format('MMMM DD, YYYY')}
                </Typography.Text>
                <Typography.Text
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 8,
                    gap: 10,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                    }}
                  >
                    <Icon component={IconMail} />
                    {this.props.user.id || '--/--'}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                    }}
                  >
                    <Icon component={IconPhone} />
                    {this.props.user.phone || '--/--'}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                    }}
                  >
                    <Icon component={IconPosition} />
                    {this.props.user.address || '--/--'}
                  </div>
                </Typography.Text>
              </Col>
              <Col xs={24} className='mt10'>
                <Collapse activeKey={['roles']}>
                  <Collapse.Panel showArrow={false} header='Roles' key={'roles'}>
                    {get(this.props.user, 'orgCtx.roles', []).map((role: string) => {
                      return (
                        <TagPrimaryColor style={{ marginBottom: 8 }} uiSetting={this.props.uiSetting}>
                          {role}
                        </TagPrimaryColor>
                      );
                    })}
                  </Collapse.Panel>
                </Collapse>
              </Col>
              <Col xs={24}>
                <Collapse activeKey={['permission']}>
                  <Collapse.Panel showArrow={false} header='Permissions' key={'permission'}>
                    {permission &&
                      isArray(permission.groupIds) &&
                      permission.groupIds.map((groupId: string) => {
                        const permissionName = get(this.props.permissionGroups.results, groupId, groupId);
                        return (
                          <TagPrimaryColor style={{ marginBottom: 8 }} uiSetting={this.props.uiSetting}>
                            {permissionName}
                          </TagPrimaryColor>
                        );
                      })}
                    {!permission || (permission && isArray(permission.groupIds) && permission.groupIds.length === 0)
                      ? 'No permissions'
                      : null}
                  </Collapse.Panel>
                </Collapse>
              </Col>
              <Col xs={24}>
                <Collapse activeKey={['login-activity']}>
                  <Collapse.Panel showArrow={false} header='Login Activity' key={'login-activity'}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 5,
                      }}
                    >
                      <div style={{ color: 'green' }}>
                        Last login successfully at{' '}
                        {activities.lastLoginSuccess && activities.lastLoginSuccess.actionAt
                          ? moment(activities.lastLoginSuccess.actionAt).format('LLLL')
                          : '--/--'}
                      </div>
                      <div style={{ color: 'red' }}>
                        Last login failed at{' '}
                        {activities.lastLoginFailed && activities.lastLoginFailed.actionAt
                          ? moment(activities.lastLoginFailed.actionAt).format('LLLL')
                          : '--/--'}
                      </div>
                      <div>
                        Last changed password at{' '}
                        {activities.lastChangePassword && activities.lastChangePassword.actionAt
                          ? moment(activities.lastChangePassword.actionAt).format('LLLL')
                          : '--/--'}
                      </div>
                      <div>
                        <Link
                          to={{
                            pathname: 'activity/login-history',
                          }}
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </Collapse.Panel>
                </Collapse>
              </Col>
            </Row>
          </Col>
        </Row>
        {this.renderDraweInfo()}
      </>
    );
  };

  render() {
    return (
      <DashboardPageLayoutV2
        props={this.props}
        selectedLeftNavStandard='my-info'
        selectedSubMenuStandard='my-info'
        breadcrumbItemsStandard={[
          {
            title: 'Home',
            path: '/',
          },
          {
            title: 'Profile',
          },
        ]}
        breadcrumbItemsModern={[
          {
            title: 'Account',
            path: '/',
          },
          {
            title: 'Profile',
            path: '//my-account-info',
          },
          {
            title: 'My Profile',
          },
        ]}
        pageTitle='Profile'
        renderContentLayout={this.renderContentLayout}
        metaTitle={this.props.ui.meta.title}
        pageTitleIcon={
          <Icon
            component={() => (
              <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M2.46644 16.3333H13.5335C14.8691 16.3333 15.5 15.9188 15.5 15.0228C15.5 12.7695 12.6476 9.53332 7.99663 9.53332C3.35234 9.53332 0.5 12.7695 0.5 15.0228C0.5 15.9188 1.13087 16.3333 2.46644 16.3333ZM2.13758 15.2167C1.80873 15.2167 1.68792 15.1298 1.68792 14.8891C1.68792 13.3311 3.96308 10.6566 7.99663 10.6566C12.0369 10.6566 14.3121 13.3311 14.3121 14.8891C14.3121 15.1298 14.1913 15.2167 13.8624 15.2167H2.13758ZM8.01003 8.39661C10.0436 8.39661 11.6812 6.61134 11.6812 4.39816C11.6812 2.22508 10.0436 0.5 8.01003 0.5C5.98322 0.5 4.33221 2.25183 4.33221 4.41153C4.33221 6.61803 5.9765 8.39661 8.01003 8.39661ZM8.01003 7.27998C6.64764 7.27998 5.52013 6.02295 5.52013 4.41153C5.52013 2.84691 6.64093 1.61662 8.01003 1.61662C9.37917 1.61662 10.4933 2.82686 10.4933 4.39816C10.4933 6.00958 9.3725 7.27998 8.01003 7.27998Z'
                  fill='currentColor'
                />
              </svg>
            )}
          />
        }
      />
    );
  }
}

export const UserInfoComponentV2 = Form.create<Props>({ name: 'profile_form' })(UserInfoForm);
